import { get, post, delete0 } from '@/utils/request'

const vodApi = {
  shortVideo: '/api/content/video/short',
  videoPostApi: '/api/content/post/video',
  videoFileApi: '/api/content/post/video/publish/file',
  updateVideoScopeApi: '/api/content/post/video/update/scope',
  updateVideoInfoApi: '/api/content/post/video/update/info',
  updateVideoCoverApi: '/api/content/post/video/update/cover',
  updateVideoFileApi: '/api/content/post/video/update/file',
  videoCategoryApi: '/api/content/video/categories',
  categoryVideoApi: '/api/content/video/category',
  userVideoPostApi: '/api/content/video/user',
  tagVideoPostApi: '/api/content/video/tag',
  videoInfoApi: '/api/content/video/detail',
  videoUrlApi: '/api/content/video/url',
  videoApi: '/api/content/video',
  videoDownloadApi: '/api/content/video/download',
  shortUrlApi: '/api/content/video/share',
  videoRecommendApi: '/api/content/video/recommend',
  similarVideoApi: '/api/content/video/similar',
  bannerVideoApi: '/api/content/video/hot',
  videoTimelineApi: '/api/content/video/timeline',
  vodAdminApi: '/api/admin/content/vod',
  visitRecordApi: '/api/content/video/visit',
  keywordSuggestApi: '/api/search/suggest',
  videoSearchApi: '/api/search/query',
  hotSearchApi: '/api/search/hot',
  userComment: '/api/comment',
  userContentDataApi: '/api/content/userdata',
  contentAccessCodeApi: '/api/content/userdata',
  ossServerApi: '/api/file/oss/serverinfo',
  ossServerApi1: '/api/content/oss/serverinfo',
  rcmdApi: '/api/content/rcmd',
  postAlbumApi: '/api/content/post/album'
}

export function getShortVideo() {
  return get(vodApi.shortVideo)
}

export function getRecentShortVideos(queryParams) {
  return get(vodApi.shortVideo + '/recent', queryParams)
}

// *********************************************************************************************************************
// 添加视频文件
export function addVideoFile(payload) {
  return post(vodApi.videoFileApi, payload)
}

// 添加视频贴
export function addVideoPost(video) {
  return post(vodApi.videoPostApi + '/publish/post', video)
}

// 更新视频可见范围
export function updateVideoScope(data) {
  return post(vodApi.updateVideoScopeApi, data)
}

// 更新视频信息
export function updateVideoInfo(data) {
  return post(vodApi.updateVideoInfoApi, data)
}

// 更新视频封面
export function updateVideoCover(data) {
  return post(vodApi.updateVideoCoverApi, data)
}

// 更新视频文件
export function updateVideoFile(data) {
  return post(vodApi.updateVideoFileApi, data)
}

// 删除视频贴
export function deleteVideoPost(payload) {
  return post(vodApi.videoPostApi + '/delete', payload)
}

// 获取视频贴列表
export function getVideoPosts(queryParams) {
  return get(vodApi.videoPostApi + '/list', queryParams)
}

export function getVideoPost(videoId) {
  return get(vodApi.videoPostApi + '/info?videoId=' + videoId)
}

// *********************************************************************************************************************
// 获取视频分类
export function videoRegion() {
  return get(vodApi.videoCategoryApi)
}

export function videoCategories() {
  return get(vodApi.videoCategoryApi)
}

// 获取分类视频
export function categoryVideos(categoryId, page) {
  return get(vodApi.categoryVideoApi + '?categoryId=' + categoryId + '&page=' + page)
}

// 获取用户视频
export function getUserVideos(userId, page) {
  return get(vodApi.userVideoPostApi + '?userId=' + userId + '&page=' + page)
}

// 获取相同标签的视频
export function getTagVideos(tag, page) {
  return get(vodApi.tagVideoPostApi + '?tag=' + tag + '&page=' + page)
}

// 获取视频详情
export function videoInfo(videoId) {
  return get(vodApi.videoInfoApi + '/' + videoId)
}

// 获取视频 URL
export function videoUrl(videoId) {
  return get(vodApi.videoUrlApi + '/' + videoId)
}

// *********************************************************************************************************************
// 下载视频
export function downloadVideo(videoId) {
  return get(vodApi.videoDownloadApi + '/' + videoId)
}

// 获取分享视频的短链接
export function getShortUrl(videoId) {
  return post(vodApi.shortUrlApi + '/' + videoId)
}

// ********************************************************************************************************************
// 获取推荐视频
export function videoRecommend(nextId) {
  return get(vodApi.videoRecommendApi + '?nextId=' + nextId)
}

// 获取相似视频
export function similarVideo(videoId) {
  return get(vodApi.similarVideoApi + '?videoId=' + videoId)
}

// 获取 banner 视频
export function getBannerVideo() {
  return get(vodApi.bannerVideoApi)
}

// 用户视频时间线
export function videoTimeline(nextId) {
  return get(vodApi.videoTimelineApi + '?nextId=' + nextId)
}

// 报告视频错误
export function videoErrorReport(data) {
  return post(vodApi.videoApi + '/error_report', data)
}

export function getAuditVideo(queryParams) {
  return get(vodApi.vodAdminApi + '/audit', queryParams)
}

export function submitAuditVideo(payload) {
  return post(vodApi.vodAdminApi + '/audit', payload)
}

export function submitEditVideo(payload) {
  return post(vodApi.vodAdminApi + '/edit', payload)
}

// 获取用户的视频观看记录
export function getVisitRecord(nextId) {
  return get(vodApi.visitRecordApi + '?nextId=' + nextId)
}

// 删除用户的视频观看记录
export function deleteVisitRecord(nextId) {
  return delete0(vodApi.visitRecordApi + '?nextId=' + nextId)
}

// 清空用户的视频观看记录
export function eraseVisitRecord(nextId) {
  return delete0(vodApi.visitRecordApi + '?nextId=' + nextId)
}

// 关键词建议
export function keywordSuggest(keyword) {
  return get(vodApi.keywordSuggestApi + '?keyword=' + keyword)
}

// 搜索关键词
export function videoQuery(keyword, pageNumber) {
  return get(vodApi.videoSearchApi + '?keyword=' + keyword + '&pageNumber=' + pageNumber)
}

// 热门搜索关键词列表
export function hotKeyword() {
  return get(vodApi.hotSearchApi)
}

// 发布评论
export function publishComment(data) {
  return post(vodApi.userComment + '/submit', data)
}

// 获取评论
export function getComment(queryInfo) {
  return get(vodApi.userComment + '/list', queryInfo)
}

// 获取评论的子评论
export function getChildComment(queryInfo) {
  return get(vodApi.userComment + '/child', queryInfo)
}

export function getCommentMap(queryInfo) {
  return get(vodApi.userComment + '/chartmap', queryInfo)
}

/** *******************************************************************************************************************/
// 获取用户内容统计
export function getUserContentData(userId) {
  return get(vodApi.userContentDataApi + '?userId=' + userId)
}

// 提交内容访问码
export function submitAccessCode(jsonData) {
  return post(vodApi.contentAccessCodeApi, jsonData)
}

export function getServerInfo(channelId) {
  return post(vodApi.ossServerApi + '?channelId=' + channelId)
}

// 获取用户的推荐模式
export function getUserRcmd() {
  return get(vodApi.rcmdApi + '/user')
}

// 设置用户的推荐模式
export function setUserRcmd(jsonData) {
  return post(vodApi.rcmdApi + '/user', jsonData)
}

// 提交用户不喜欢的视频
export function rcmdFeedback(jsonData) {
  return post(vodApi.rcmdApi + '/feedback', jsonData)
}

// 创建合集
export function createAlbum(jsonData) {
  return post(vodApi.postAlbumApi + '/create', jsonData)
}

export function setAlbumCover(jsonData) {
  return post(vodApi.postAlbumApi + '/cover', jsonData)
}

// 收藏(取消收藏)内容
export function doAlbumAction(jsonData) {
  return post(vodApi.postAlbumApi + '/action', jsonData)
}

// 获取用户合集稿件的 select-list
export function getUserAlbumSelectList(queryInfo) {
  return get(vodApi.postAlbumApi + '/kv', queryInfo)
}

// 获取用户的合集稿件
export function getUserAlbumList(queryInfo) {
  return get(vodApi.postAlbumApi + '/list', queryInfo)
}

// 获取合集内容
export function getAlbumItems(queryInfo) {
  return get(vodApi.postAlbumApi + '/items', queryInfo)
}

export function getWatchLaterList() {
  return get(vodApi.postAlbumApi + '/watch_later')
}
